import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { SupportedLocale } from "src/utils/helpers";

const parseLang = (locale: string) => {
    return String(locale).split("-")[0];
};

export interface Locale {
    lang: string;
    locale: string;
    setLang(lang: string);
    setLocale(locale: string);
}

export const useLocale = (locale?: string): Locale => {
    const [_locale, setLocale] = useState(locale);

    const localeLang = useMemo(() => {
        if (!locale) {
            return undefined;
        }

        return parseLang(locale);
    }, [locale]);

    const [lang, setLang] = useState(localeLang);

    useEffect(() => {
        setLang(localeLang);
    }, [localeLang]);

    return {
        locale: _locale,
        lang,
        setLocale,
        setLang,
    };
};

export const useSystemLocale = (): Locale => {
    const { i18n } = useTranslation();

    return useLocale(i18n?.language);
};

export const useContentLocale = (initialLocale?: string) => {
    const locale = useLocale(initialLocale);
    const supportedLocales = Object.values(SupportedLocale);

    return {
        ...locale,
        locales: supportedLocales,
        langs: supportedLocales.map(parseLang),
    };
};

export const useCountries = () => {
    const countries = [
        { code: "cz" },
        { code: "sk" },
        { code: "de" },
        { code: "pl" },
        { code: "at" },
        { code: "hu" },
        { code: "ch" },
        { code: "it" },
        { code: "fr" },
        { code: "es" },
        { code: "gb" },
    ];

    return { countries };
};
